const CDN_BASE_URL = 'https://d3877099hb8oti.cloudfront.net'
const BP_TABLET = 1024
const BASE_WIDTH_MOBILE = 430
const BASE_WIDTH_DESKTOP = 430

export { CDN_BASE_URL, BP_TABLET, BASE_WIDTH_MOBILE, BASE_WIDTH_DESKTOP }